import { Loader2, Check } from 'lucide-react';
import { Button } from '@/components/ui/button.js';
import { cn } from '@/lib/utils.js';
import type { ComponentPropsWithoutRef } from 'react';

export type MutationState = 'idle' | 'saving' | 'saved' | 'error';

interface MutationButtonProps extends Omit<ComponentPropsWithoutRef<typeof Button>, 'children'> {
  state: MutationState;
  idleLabel: string;
  savingLabel?: string;
  savedLabel?: string;
  errorLabel?: string;
}

export function MutationButton({
  state,
  idleLabel,
  savingLabel = 'Saving…',
  savedLabel = 'Saved',
  errorLabel = 'Error — retry',
  disabled,
  className,
  ...props
}: MutationButtonProps) {
  const isBusy = state === 'saving';
  return (
    <Button
      {...props}
      disabled={disabled ?? isBusy}
      aria-disabled={isBusy}
      className={cn(
        'gap-2 transition-all',
        state === 'error' && 'border-[oklch(0.55_0.16_25)] text-[oklch(0.55_0.16_25)]',
        className
      )}
    >
      {state === 'saving' && <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden="true" />}
      {state === 'saved' && <Check className="h-3.5 w-3.5" aria-hidden="true" />}
      {state === 'idle' && idleLabel}
      {state === 'saving' && savingLabel}
      {state === 'saved' && savedLabel}
      {state === 'error' && errorLabel}
    </Button>
  );
}
